import { render, staticRenderFns } from "./BaseOption.vue?vue&type=template&id=0d60cca2&"
import script from "./BaseOption.vue?vue&type=script&lang=ts&"
export * from "./BaseOption.vue?vue&type=script&lang=ts&"
import style0 from "./BaseOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports